import { parseQuotationDTOList, QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { QuotationStatus } from 'components/ordering/quotation/api/dtos/quotation-status.js'
import { QuotationRequest } from 'components/ordering/quotation/api/quotation-request.js'

export type GetQuotationsPayload = {
  status?: QuotationStatus
  userId?: number
}

const isDefined = <T>(value: T | undefined): value is T => value !== undefined

export class ListQuotations extends QuotationRequest<QuotationDTO[], never> {
  path: string

  constructor({ status, userId }: GetQuotationsPayload = {}) {
    super()

    const params = Object
      .entries({
        status: status,
        requested_user_id: userId,
      })
      .filter(([, value]) => isDefined(value))
      // The `?? ''` is to convince Typescript that no undefined values ever come out,
      // even though we've filtered them already. Silly Typescript...
      .map(([key, value]) => ([key, value?.toString() ?? '']))

    const queryString = new URLSearchParams(params).toString()
    this.path = `quotation/${queryString ? `?${queryString}` : ''}`
  }

  override parseResponse = parseQuotationDTOList
}
